// Written by scripts/stamp.js on every build. The value committed is
// a placeholder, so a fresh clone compiles before anything is run.
export const BUILD_STAMP = "e15f6e54fbf05fb2678d6ac4bace21d284ee2c60";
